@if (chartOptions) {
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    [(update)]="isChartUpdated"
  [runOutsideAngular]="true"></highcharts-chart>
}
